export default {
    active: true,
    customTags: [],
    displayAskQuestion: true,
    disableAskNewQuestionFromUi: false,
    id: null,
    labels: {
        askBubble: "Ask\nan Expert",
        askButton: "Send to our experts",
        askFormHeader: "How can we help you?",
    },
    metadata: {},
    questionCategory: "",
    userEmail: "",
    userName: "",
    userPhone: "",
    showDisclaimer: false,
    forceRecaptcha: false,
};
